import React from "react";
import { useParams, Link } from "react-router-dom";
import { Row, Col, Card, Label, Button } from "reactstrap";
import { getSale } from "../../api/sales";
import { getCustomer, getCustomerVehicles } from "../../api/customers";
import PageLayout from "../../components/PageLayout";
import FileList from "../../components/FileList";
import Loading from "../../components/Loading";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import moment from "moment"
import { getCollaudiForSale } from "../../api/collaudo"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DropdownFilterElement, filterDate, getDate } from "../../components/TableUtils";
import classNames from 'classnames';


const SaleDoc = () => {
    const { id } = useParams();
    const [customer, setCustomer] = React.useState();
    const [loading, setLoading] = React.useState(true);
    const [sale, setSale] = React.useState();
    const [collaudi, setCollaudi] = React.useState();
    const [expanedCollaudoDocs, setExpanedCollaudoDocs] = React.useState();;
    const { geo } = useAuth0();

    React.useEffect(() => {
        onLoad(id)
    }, [id])

    const onLoad = async id => {
        try {
            setLoading(true);
            const saleRes = await getSale(id);
            const customerVehicles = await getCustomerVehicles(saleRes.customer_id)
            const custRes = await getCustomer(saleRes.customer_id)
            const saleVehIds = saleRes.meta && saleRes.meta.vehicles ? saleRes.meta.vehicles.map(el => el._id) : []
            const saleVehicles = customerVehicles.filter(el => saleVehIds.includes(el._id))
            saleRes.meta.vehicles = saleVehicles;
            if (saleRes.meta.vehicles && saleRes.meta.vehicles.length) {
                const collaudoRes = await getCollaudiForSale(saleRes._id);
                setCollaudi(collaudoRes)
            }
            setCustomer(custRes);
            setSale(saleRes)
        } finally {
            setLoading(false);
        }
    };


    const renderCustomer = () => {
        if (!customer) return null;

        const showCollaudi =
            sale.meta && sale.meta.product && sale.meta.product.needsAuto
                ? sale.meta.product.needsAuto.toString() === "true"
                : false;

        return (
            <Card body color="default">
                <Row>
                    <Col sm="6" xs="12">
                        <strong className="mt-1 d-block">Ragione Sociale / Cognome - Nome</strong>
                        <Label className="mt-1 d-block h5">{customer.name}</Label>
                    </Col>
                    <Col sm="6" xs="12" md="3">
                        <strong className="mt-1 d-block">C.F. / P.iva</strong>
                        <Label className="mt-1 d-block h5">{customer.taxcode}</Label>
                    </Col>
                    <Col sm="6" xs="12" md="3">
                        <strong className="mt-1 d-block">Telefono</strong>
                        <Label className="mt-1 d-block h5">{customer.attributes.phone}</Label>
                    </Col>
                    <Col sm="6" xs="12">
                        <strong className="mt-1 d-block">Email</strong>
                        <Label className="mt-1 d-block h5">{customer.email}</Label>
                    </Col>
                    <Col sm="6" xs="12">
                        <strong className="mt-1 d-block">Indirizzo</strong>
                        <Label className="mt-1 d-block h5">{customer.address ? `${
                            customer.address.street
                            } ${geo.getComuneLabel(customer.address.city)} ${
                            customer.address.cap
                            } ${geo.getProvinceLabel(
                                customer.address.province
                            )} (${customer.address.province.toUpperCase()} regione ${geo.getRegioneLabel(
                                customer.address.region
                            )})` : null}}</Label>
                    </Col>
                    <Col sm="6" xs="12">
                        <strong className="mt-1 d-block">Prodotto</strong>
                        <Label className="mt-1 d-block h5">{sale.meta.product.label}</Label>
                    </Col>
                    <Col sm="6" xs="12" md="3">
                        <strong className="mt-1 d-block">Quantità</strong>
                        <Label className="mt-1 d-block h5">{sale.attributes.quantity}</Label>
                    </Col>
                    <Col sm="6" xs="12" md="3">
                        <strong className="mt-1 d-block">Prezzo unitario</strong>
                        <Label className="mt-1 d-block h5">{`Euro ${sale.meta.product.price}`}</Label>
                    </Col>
                    <Col sm="6" xs="12">
                        <strong className="mt-1 d-block">Effettuata da</strong>
                        <Label className="mt-1 d-block h5">{sale.createdby}</Label>
                    </Col>
                    <Col sm="6" xs="12" md="3">
                        <strong className="mt-1 d-block">Data</strong>
                        <Label className="mt-1 d-block h5">{moment(sale.createdat).format("DD/MM/YYYY")}</Label>
                    </Col>
                    <Col sm="6" xs="12" md="3">
                        <strong className="mt-1 d-block">Totale</strong>
                        <Label className="mt-1 d-block h5">{`Euro ${Number(sale.meta.product.price) * Number(sale.attributes.quantity)}`}</Label>
                    </Col>
                    {sale.meta.vehicles && sale.meta.vehicles.length ? (<Col xs="12">
                        <div className="divider my-3" />
                        <strong className="mt-1 d-block">Veicoli associati:</strong>
                        <DataTable
                            responsive
                            autoLayout={false}
                            value={sale.meta.vehicles}
                            className="p-datatable-hoverable-rows p-datatable-customers"
                            emptyMessage={() => (<div className="text-center">Nessun veicolo associato alla vendita</div>)}
                            paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                            currentPageReportTemplate="Visualizzati {first} di {last} Veicoli su un totale di {totalRecords}"
                        >
                            <Column
                                field="plate"
                                style={{ wordWrap: "break-word" }}
                                header="Targa"
                                sortable
                                filter
                                filterMatchMode="contains"
                                body={(rowData, column) => {
                                    return (
                                        <Link
                                            to={`/tenant/vehicles/${rowData._id}`}
                                        >
                                            {rowData.plate.toUpperCase()}
                                        </Link>
                                    );
                                }}
                            />
                            <Column
                                field="attributes.frame"
                                style={{ wordWrap: "break-word" }}
                                header="Telaio"
                                sortable
                                filter
                                filterMatchMode="contains"
                            />
                            <Column
                                field="attributes.make"
                                style={{ wordWrap: "break-word" }}
                                header="Marca"
                                sortable
                                filter
                                filterMatchMode="contains"
                            />
                            <Column
                                field="attributes.model"
                                style={{ wordWrap: "break-word" }}
                                header="Modello"
                                sortable
                                filter
                                filterMatchMode="contains"
                            />
                            <Column
                                field="attributes.preparation"
                                style={{ wordWrap: "break-word" }}
                                header="Allestimento"
                                sortable
                                filter
                                filterMatchMode="contains"
                            />
                            <Column
                                field="attributes.supplier"
                                style={{ wordWrap: "break-word" }}
                                header="Alimentazione"
                                sortable
                                filter
                                filterMatchMode="contains"
                            />
                        </DataTable>
                    </Col>) : null}
                    {showCollaudi ? (<Col xs="12">
                        <div className="divider mt-4 mb-2" />
                        <strong className="mt-1 d-block">Collaudi:</strong>
                        <DataTable
                            value={collaudi}
                            responsive
                            autoLayout={false}
                            className="p-datatable-hoverable-rows p-datatable-customers"
                            emptyMessage={() => (<div className="text-center">Nessun collaudo effettuato o da terminare</div>)}
                            expandedRows={expanedCollaudoDocs || []}
                            onRowToggle={(e) => setExpanedCollaudoDocs(e.data)}
                            paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                            currentPageReportTemplate="Visualizzati {first} di {last} Collaudi su un totale di {totalRecords}"
                            dataKey="imei"
                            rowExpansionTemplate={(rowData) =>
                                <div style={{ backgroundColor: "#000" }}
                                >
                                    <FileList
                                        category="collaudo"
                                        initDocs={rowData.meta.docs}
                                        blockDelete={(name) => name.startsWith('certificatocollaudo')}
                                    />
                                </div>}
                        >
                            <Column expander={true} style={{ width: '2em' }} />
                            <Column
                                field="createdat"
                                header="Inserito il"
                                sortable
                                filter
                                body={getDate}
                                filterMatchMode="custom"
                                filterFunction={filterDate}
                                style={{ wordWrap: "break-word" }}
                            />
                            <Column
                                field="attributes.plate"
                                header="Targa"
                                sortable
                                filter
                                style={{ wordWrap: "break-word" }}
                            />
                            <Column
                                field="createdby"
                                header="Operatore"
                                sortable
                                filter
                                style={{ wordWrap: "break-word" }}
                            />
                            <Column
                                field="status"
                                header="Stato"
                                sortable
                                filter
                                style={{ wordWrap: "break-word" }}
                                filterElement={
                                    <DropdownFilterElement
                                        field="status"
                                        options={[
                                            { label: "inserito", value: "inserito" },
                                            { label: "firmato", value: "firmato" },
                                            { label: "da firmare", value: "giscomplete" }
                                        ]}
                                        onChange={e => dtable.filter(e.value, e.field)}
                                    />
                                }
                                style={{ wordWrap: "break-word", textAlign: "center" }}
                                body={(rowData, column) => {
                                    return (
                                        <span className={classNames('customer-badge', 'status-' + rowData.status)}>{rowData.status !== 'giscomplete' ? rowData.status : 'da firmare'}</span>
                                    );
                                }}
                            />

                        </DataTable>
                    </Col>) : null}
                    <Col xs="12">
                        <Button
                            className="mr-2 mt-2 float-right"
                            color="warning"
                            label="Torna"
                            onClick={() => {
                                history.go(-1);
                            }}
                        >
                            <FontAwesomeIcon icon="reply" /> Torna
                        </Button>
                    </Col>
                </Row>
            </Card>
        );
    };

    if (loading) return <Loading />;

    return (
        <PageLayout
            title={`Riepilogo Vendita: Veicoli e Collaudi`}
            optionalNav={{ link: `/tenant/sales`, text: "Vendite" }}
            redirRoot={`/tenant/sales`}
        >
            <Row>
                <Col>{renderCustomer()}</Col>
            </Row>
        </PageLayout>
    );
};
export default SaleDoc;
